 <template>
      <div>
          <div v-if="$can(abilities.STATS_PROJECT)" class="row mb-10">
            <div class="col-12">
              <Card class="card shadow-sm p-10">
                <h2>{{ $t('projects.stats') }}</h2>
                <div class="mt-5">
                  <div class="d-flex overflow-auto flex-nowrap gap-4 p-3">
                    <div
                        class="col-2 mb-2 flex-shrink-0"
                        v-for="(stat, index) in projectStatusStat"
                        :key="index"
                    >
                      <div class="card shadow-sm d-flex justify-content-center align-items-start p-5 class-h h-100">
                        <div class="d-flex align-items-center">
                          <span
                              class="badge badge-square fs-6 p-5"
                              :style="{backgroundColor: stat.color}"
                              :class="'badge-'+stat.color"
                          >
                            {{ stat.count }}
                          </span>
                          <div class="fs-6 ms-5">{{ stat[locale] }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <Card :title="$t('projects.list')">
                <template #cardToolbar>
                  <ButtonDropdownFilter
                      :btn-title="$t('projects.label.cat')"
                      :options="[...categories]"
                      value-field="id"
                      name-field="name"
                      v-model="filterProject.project_category_id"
                  />
                </template>
                <CategoryGroupFilter v-model="filterProject.project_category_group_id"/>
                <div class="card-body">
                  <ProjectListView :filter="filterProject" @reloadDatatable='loadData' :action="false" />
                </div>
               
              </Card>
            </div>
          </div>
      </div>
 </template>
  <script setup>
  
  import Card from "@/components/Card.vue";
  import {useRoute} from "vue-router";
  import {useStore} from "vuex";
  import {useLocales} from "@/composables/locales";
  import {computed, ref, watch, onMounted} from "vue";
  import abilities from "@/composables/abilities";
  import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
  import CategoryGroupFilter from "@/Modules/Projects/views/Projects/components/CategoryGroupFilter.vue";
  import ProjectListView from "@/Modules/Projects/views/Projects/ListView.vue";

  const route = useRoute()
  const store = useStore()
  const {locale} = useLocales()
  const props = defineProps({
    filters : {type: Object, default: {}},
  })

  const refreshKey = ref(0)

  const filterProject = ref({
    office: '',
    contact_id: route.params.id,
    project_category_id: '',
    project_category_group_id:'',
    reload: 0,
    ...props.filters,
    status: '',
  })

  watch(() => route.params.id, (value) => {
    if(value){
      filterProject.value.contact_id = value
    }
  })


  const projectStatusStat = ref({})
  const getFistOffice = ref("")
  
  const offices = computed(() => (store.getters['offices/getSocietyOffices']))
  const currentCompany = computed(() => store.getters['offices/getSelectedCompany'])

  const categories = computed(() => store.getters['projectCategories/getProjectCategories'])

  watch(() => currentCompany.value, (value) => {
    if(value){
     store.dispatch("offices/loadSocietyOffices", value?.id)
    }
  })

  watch(() => offices.value, (value) => {
    if(value){
      getFistOffice.value = value[0]
    }
  })

  watch(() => getFistOffice.value, (value) => {
    if(value){
      filterProject.value.office = getFistOffice.value?.id
    }
  })
  
  watch(() => [
    filterProject.value.start_date,
    filterProject.value.end_date,
    filterProject.value.contact_id,
  ], (newValue) => {
    loadStat()
  })

  async function loadStat() {
    await store.dispatch('projects/getProjectStatusStat', filterProject.value).then((res) => {
      projectStatusStat.value = res.data
    })
  }

  function loadData(){
    refreshKey.value++
    filterProject.value.reload += 1
    loadStat()
  }
  
  onMounted(() => {
    store.dispatch("projectCategories/loadProjectCategories")
    if(currentCompany.value){
      store.dispatch("offices/loadSocietyOffices", currentCompany.value?.id)
    }
    loadStat()
  })
  
</script>

<style scoped>
  .table-container {
    height: 350px;
    overflow-y: auto;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 1;
  }

  .class-h {
    min-height: 65px !important;
  }
</style>